/**
 * Luxury Collection Cards — mobile swipe carousel.
 * Native finger-swipe via CSS scroll-snap. No visible indicators.
 * This script only adds a small "settle" correction: if the swipe
 * ends up stopped between two cards (can happen with fast flicks or
 * with mouse-drag emulation in preview tools), it gently finishes
 * the scroll to the nearest card.
 */
(function () {
  function initInstance(root) {
    if (!root || root.dataset.lccInitialized) return;
    root.dataset.lccInitialized = 'true';

    var track = root.querySelector('.lcc-track');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.lcc-card'));
    if (!track || !cards.length) return;

    var settleTimer = null;

    function nearestCard() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closest = cards[0];
      var closestDist = Infinity;
      cards.forEach(function (card) {
        var r = card.getBoundingClientRect();
        var cardCenter = r.left + r.width / 2;
        var dist = Math.abs(cardCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = card;
        }
      });
      return closest;
    }

    function onScroll() {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        var target = nearestCard();
        var diff = Math.abs(track.scrollLeft - target.offsetLeft);
        if (diff > 2) {
          track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      }, 120);
    }

    track.addEventListener('scroll', onScroll, { passive: true });
  }

  window.LuxuryCollectionCards = {
    init: function (root) {
      initInstance(root);
    }
  };

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.lcc-wrapper');
    if (root) initInstance(root);
  });
})();